<script lang="ts">
	import voucherImage from "../../../../core/assets/voucher.jpg?w=150?webp&imagetools";
	import { getVoucherPath } from "../../../../core/schema/paths/getVoucherPath.js";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import ProductImageWithCounter from "./ProductImageWithCounter.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import type { OrderVoucher } from "../../../../core/schema/OrderVoucher.js";
	import type { Order } from "../../../../core/schema/Order.js";

	export let voucher: OrderVoucher;
	export let order: Order;

	const globalSettings = getGlobalSettings();
	const { TENANT_LOCALE } = globalSettings;
</script>

<div class="border-t-1 inline-flex w-full flex-wrap justify-between border-gray-200 p-4 md:p-6">
	<div class="flex w-full gap-2 md:gap-4">
		<ProductImageWithCounter
			image={voucherImage}
			size={88}
			imgClass="min-w-[3.5rem] md:min-w-[5.5rem] md:w-[5.5rem] w-[3.5rem] md:h-[5.5rem] h-[3.5rem] object-contain"
			path={getVoucherPath(TENANT_LOCALE, voucher.orderVoucherProduct)}
			quantity={voucher.quantity}
		/>
		<div class="flex w-full items-start justify-between">
			<p class="md:text-md text-base font-semibold">{voucher.orderVoucherProduct.name[TENANT_LOCALE]}</p>
			{#if order.products.length > 0 || order.appliedVoucher !== undefined || order.vouchers.length > 1}
				<p class="text-md hidden font-semibold lg:inline">
					{formatPrice(voucher.orderVoucherProduct.value, TENANT_LOCALE, false)}
				</p>
			{/if}
		</div>
	</div>
	{#if order.products.length > 0 || order.appliedVoucher !== undefined || order.vouchers.length > 1}
		<p class="ml-auto mt-3 font-semibold lg:hidden">
			{formatPrice(voucher.orderVoucherProduct.value, TENANT_LOCALE, false)}
		</p>
	{/if}
</div>
